export default {"src":"/_next/static/media/about.b71d321d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};